import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useDispatch } from "react-redux";
import { toastAlert } from "../../lib/toastAlert";
import {MatEditor} from "maticzeditor"
import { sendSubscriberMail } from '../../actions/users';
import { useNavigate } from 'react-router-dom';

const SubscriberAdd = () => {
    const navigate = useNavigate()
    const [validateError, setValidateError] = useState({});
	const [categoryname, setCategoryname] = useState('');
	const [subject, setsubject] = useState("");
	const [mailData, setMailData] = useState("");

    const handleFormSubmit = async (e) => {
		e.preventDefault();
        toastAlert("update", "Sending Mail.. Please wait")
		var type = categoryname.categoryname;
		let reqData = {
			subject : subject,
			boc : mailData

		}
		let sentSubMail = await sendSubscriberMail(reqData);
		if (sentSubMail && sentSubMail.data && sentSubMail.data && sentSubMail.data.Success) {
            toastAlert('success', "Mail Successfully Sent")
				setTimeout(() => {
					window.location.reload();
				},2000);
		} else {
            toastAlert('success', "Mail Successfully Sent")
		}
	}
    const onChange = (e) => {
		setsubject(e.target.value)
	}
    const onEditorChange = (evt) => {
		var description_text = evt
		setMailData(description_text);
	}
    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'News Letter'} />
                        <div className='common_page_scroller mt-5 pe-2'>

                            <form noValidate onSubmit={handleFormSubmit} autoComplete="off">
                            <div className="addcategorys">
                                    <h4>News Letter</h4>
                                    <p>Create a NewsLetter</p>
                                </div>
                                <div className="categorylisdt">
                                <div className='row'>
                                <div className='col-xl-7 mt-3'>
                                        <label className='mb-2'>Subject</label>
                                        <input
                                        placeholder='subject'
                                        className='form-control'
                                            type="text"
                                            id="subject"
                                            value={subject || ''}
                                            onChange={onChange}
                                            fullWidth
                                        />
                                        {validateError.question && (
                                            <span className="text-danger">{validateError.question}</span>
                                        )}
                                    </div>
                                </div>
                                
                                <div className='col-xl-7 mt-3'>
                                        <label className='mb-2'>Content</label>
                                        <MatEditor sendata={mailData} outdata={(evt) => onEditorChange(evt)} />
                                        {validateError.answer && (
                                            <span className="text-danger">{validateError.answer}</span>
                                        )}
                                    </div>
                                </div>
                                
                                <div>
                                    <button className='btn addcate mt-3 mb-4 ms-2' type="submit">Send</button>
                                </div>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default SubscriberAdd